// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"3ddce89b","229":"bed269bd","296":"b95d10c3","378":"b394498b","404":"fc97e916"}[chunkId] + ".chunk.js";
};